import { cva } from "@-/com.npmjs.cva";
import { cn } from "@-/com.npmjs.cn";
import { Platform } from "@-/com.npmjs.react-native";

export const textVariants = cva({
  base: cn(
    "font-sans text-base font-normal text-foreground",
    Platform.select({
      web: "select-text",
    }),
  ),
  defaultVariants: {
    colorVariant: "default",
    variant: "default",
  },
  variants: {
    colorVariant: {
      default: "",
      destructive: "text-destructive",
      inverse: "text-primary-foreground",
      muted: "text-muted-foreground",
    },
    variant: {
      blockquote: "mt-4 border-l-2 pl-3 italic sm:mt-6 sm:pl-6",
      code: cn(
        "relative rounded-xs bg-muted px-[0.3rem] py-[0.2rem] font-mono text-sm font-semibold",
      ),
      default: "",
      glyph: "",
      h1: cn(
        "text-center text-4xl font-extrabold tracking-tight",
        Platform.select({ web: "scroll-m-20 text-balance" }),
      ),
      h2: cn(
        "border-b border-border pb-2 text-3xl font-semibold tracking-tight",
        Platform.select({ web: "scroll-m-20 first:mt-0" }),
      ),
      h3: cn("text-2xl font-semibold tracking-tight", Platform.select({ web: "scroll-m-20" })),
      h4: cn("text-xl font-semibold tracking-tight", Platform.select({ web: "scroll-m-20" })),
      large: "text-lg font-semibold",
      lead: "text-xl text-muted-foreground",
      link: cn("underline", Platform.select({ web: "underline-offset-4" })),
      muted: "text-sm text-muted-foreground",
      // A ratio (28px at the default 16px) rather than `leading-7`'s fixed 28px, so paragraph lines
      // keep their spacing when the slide text size setting rescales `text-base`.
      p: "mt-3 leading-[1.75] sm:mt-6",
      small: "text-sm leading-none font-medium",
    },
  },
});
